<template>
  <div class="add-org">
    <ep-title title="添加单位"></ep-title>
    <div class="org-form">
      <Entform v-if="orgState==0" ref="addenf" @change="onSubmitenf"></Entform>
      <Govform v-if="orgState==1" ref="addgov" @change="onSubmitgov"></Govform>
      <Parkform v-if="orgState==2" ref="addpark" @change="onSubmitpark"></Parkform>
      <Wtfrom v-if="orgState==3" ref="addwtf" @change="onSubmitwtf"></Wtfrom>
      <Otherform v-if="orgState==4" ref="addother" @change="onSubmitother"></Otherform>
    </div>
    <div class="org-control">
      <el-button type="primary" @click="confirm">提交</el-button>
    </div>
  </div>
</template>
<script>
import Entform from '../../components/plan/Entform'
import Parkform from '../../components/plan/Parkform'
import Wtfrom from '../../components/plan/Wtform'
import Govform from '../../components/plan/Govform'
import Otherform from '../../components/plan/Otherform'
import company from '../../data/basic/plan/company.js'
import { normalizeCountByType, isTypeAtLimit, limitMessage } from '../../data/basic/plan/unitLimit.js'

export default {
  data() {
    return {
      orgState: 0,
      form: [],
      registryState: {},
      other_list: {},
      datalist: null,
    }
  },
  created() {
    this.orgState = sessionStorage.orgStatuID
  },
  methods: {
    async ensureWithinLimit() {
      const type = Number(this.orgState)
      let getState = await company.get_member_count_by_type()
      if (!getState.status) {
        this.$message.error(getState.msg || '单位数量查询失败，请稍候重试')
        return false
      }
      const countByType = normalizeCountByType(getState.data)
      if (isTypeAtLimit(countByType, type)) {
        this.$message.warning(limitMessage(type))
        return false
      }
      return true
    },
    // 提交表单
    // 判断数据根据类型
    async confirm() {
      if (!await this.ensureWithinLimit()) {
        return
      }
      if (this.orgState == 0) {
        this.$refs['addenf'].onSubmitenf()
      } else if (this.orgState == 1) {
        this.$refs['addgov'].onSubmitgov()
      } else if (this.orgState == 2) {
        this.$refs['addpark'].onSubmitpark()
      } else if (this.orgState == 3) {
        this.$refs['addwtf'].onSubmitwtf()
      } else if (this.orgState == 4) {
        this.$refs['addother'].onSubmitother()
      }
    },
    // 提交企业表单
    onSubmitenf(form) {
      (async () => {
        let entp_list = await company.create_entp(form)
        if (entp_list.status) {
          this.$router.push('/myunit')
          this.$message.success('申报单位新增成功');
        } else {
          // this.$message.error(entp_list.msg);
          this.$alert(entp_list.msg, '提示', {
            confirmButtonText: '确定',
          });

        }
      })()
    },
    // 提交政府
    onSubmitgov(form) {
      (async () => {
        let gov_list = await company.create_gov(form)
        if (gov_list.status) {
          this.$router.push('/myunit')
          this.$message.success('申报单位新增成功');
        } else {
          // this.$message.error(entp_list.msg);
          this.$alert(gov_list.msg, '提示', {
            confirmButtonText: '确定',
          });
        }
      })()
    },
    // 工业园区
    onSubmitpark(form) {
      (async () => {
        let zone_list = await company.create_zone(form)
        if (zone_list.status) {
          this.$router.push('/myunit')
          this.$message.success('申报单位新增成功');
        } else {
          // this.$message.error(entp_list.msg);
          this.$alert(zone_list.msg, '提示', {
            confirmButtonText: '确定',
          });
        }
      })()
    },
    // 水源地
    onSubmitwtf(form) {
      (async () => {
        let water_list = await company.create_water(form)
        if (water_list.status) {
          this.$message.success('申报单位新增成功');
          this.$router.push('/myunit')
        } else {
          // this.$message.error(entp_list.msg);
          this.$alert(water_list.msg, '提示', {
            confirmButtonText: '确定',
          });
        }
      })()
    },
    // 其他
    onSubmitother(form) {
      (async () => {
        let other_list = await company.create_other(form)
        if (other_list.status) {
          this.$router.push('/myunit')
          this.$message.success('申报单位新增成功');
        } else {
          // this.$message.error(entp_list.msg);
          this.$alert(other_list.msg, '提示', {
            confirmButtonText: '确定',
          });
        }
      })()
    },

  },
  components: {
    Entform,
    Parkform,
    Wtfrom,
    Govform,
    Otherform
  }
}

</script>
<style lang="stylus" scoped>
.org-form {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-top: 20px;
}

.org-control {
  margin-left: 125px;
  margin-bottom: 22px;
}

</style>



// WEBPACK FOOTER //
// addunit.vue?46ac7c28